import { render, staticRenderFns } from "./TopTenBanksByNumberFiled.vue?vue&type=template&id=8887d982&"
import script from "./TopTenBanksByNumberFiled.vue?vue&type=script&lang=js&"
export * from "./TopTenBanksByNumberFiled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports